export const mapboxGlyphs = 'mapbox://fonts/mapbox/{fontstack}/{range}.pbf';

interface TMapStyle {
  name: string;
  layers: {
    id: string;
    maxzoom: number;
    minzoom: number;
    source: string;
    type: string;
  }[];
  sources: {
    [key: string]: {
      attribution: string;
      copyrightText: string;
      maxzoom: number;
      minzoom: number;
      tileSize: number;
      tiles: string[];
      type: string;
    };
  };
  version: 8;
  glyphs: string;
  sprite?: string;
}

interface GetMapStyleProps {
  id: string;
  name: string;
  attribution: string;
  tileUrl: string;
  tileSize?: number;
}

export function getMapStyle({ id, name, attribution, tileSize, tileUrl }: GetMapStyleProps): TMapStyle {
  const source = {
    attribution,
    copyrightText: attribution,
    maxzoom: 23,
    minzoom: 0,
    tileSize: tileSize || 256,
    tiles: [tileUrl],
    type: 'raster',
  };

  const style: TMapStyle = {
    name,
    layers: [
      {
        id,
        maxzoom: 23,
        minzoom: 0,
        source: id,
        type: 'raster',
      },
    ],
    sources: {},
    version: 8,
    glyphs: mapboxGlyphs,
  };

  style.sources[id] = source;

  return style;
}
